module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAAAXElEQVQ4T2OUc9r7n4FGgHHUcGwhOxosWNPbaLCMBgvxBdFoasGdWv4zMPxlYGSse7zXqZ2BgYFq5TujnOPed4yMDNEP9zlvJz6qiFPJKOu0V/nxPue7xCknTRUALDcy1F3pl+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUsImg/juXing.png
// module id = hQuD
// module chunks = 1